var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Keyboard } from ".";
import { SortByQueryOptions } from "../api/types";
import BPMSlider from "./BPMSlider";
import { Popper, ClickAwayListener } from "@material-ui/core";
import { FadeAnimation } from "./utility";
import { DropdownButton } from "./buttons";
import { CHEVRON_DOWN_SVG } from "../assets";
import { BPMSoundsGeneric } from "../generic";
var ONE_SHOT = { id: '76858eeb-decb-4128-b361-11458e649bbf', name: 'One-Shot' };
var LOOPS = { id: '346cec97-6aa2-4261-ba1b-ffaa31d0b250', name: 'Loop' };
var sortByToText = function (sortBy) {
    switch (sortBy) {
        case SortByQueryOptions.DateAsc:
            return 'Oldest';
        case SortByQueryOptions.Relevance:
            return 'Most Popular';
        case SortByQueryOptions.NameAsc:
            return 'A-Z';
        case SortByQueryOptions.NameDesc:
            return 'Z-A';
        case SortByQueryOptions.BPMAsc:
            return 'BPM 0 - 200';
        case SortByQueryOptions.BPMDesc:
            return 'BPM 200 - 0';
        case SortByQueryOptions.DateDesc:
        default:
            return 'Newest';
    }
};
var Filter = function (props) {
    var _a = React.useState([]), genres = _a[0], setGenres = _a[1];
    var _b = React.useState([]), instruments = _b[0], setInstruments = _b[1];
    var _c = React.useState(false), showKeyboard = _c[0], setShowKeyboard = _c[1];
    var _d = React.useState(false), showBPM = _d[0], setShowBPM = _d[1];
    var _e = React.useState(false), showLength = _e[0], setShowLength = _e[1];
    var keyDropDown = React.useRef(null);
    var bpmDropDown = React.useRef(null);
    React.useEffect(function () {
        BPMSoundsGeneric.get().loadGenres().then(function (genres) {
            setGenres(genres);
        });
    }, []);
    React.useEffect(function () {
        setInstruments(props.tags.filter(function (tag) {
            return tag.TagGroup && tag.TagGroup.TagCategory && tag.TagGroup.TagCategory.name == 'Instruments';
        }));
    }, [props.tags]);
    var groups = Array.from(instruments.reduce(function (set, tag) {
        set.add(tag.tag_group_id);
        return set;
    }, new Set()));
    var hasInstruments = false;
    var instrumentButtons = groups.map(function (groupId) {
        var _a;
        var currentTags = instruments.filter(function (t) { return t.tag_group_id == groupId; });
        return {
            text: currentTags[0].TagGroup.name,
            selected: (_a = props.selectedTagGroup) === null || _a === void 0 ? void 0 : _a.includesLowercase(currentTags[0].TagGroup.name),
            onClick: function () {
                props.onTagGroupClick(currentTags[0].TagGroup);
            },
            subItems: currentTags.map(function (tag) {
                var selected = (props.selectedTags || []).includes(tag.id) || (props.selectedTags || []).includesLowercase(tag.name);
                if (selected) {
                    hasInstruments = true;
                }
                return {
                    text: tag.name,
                    selected: selected,
                    onClick: function () {
                        props.onTagClick(tag);
                    }
                };
            })
        };
    });
    //^ NEWEST
    var renderNewest = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(DropdownButton, { className: (props.sortBy) ? 'has-filter' : '', buttonText: sortByToText(props.sortBy), buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", menuItems: Object.keys(SortByQueryOptions).map(function (key) {
                    return {
                        text: sortByToText(SortByQueryOptions[key]),
                        selected: props.sortBy == SortByQueryOptions[key],
                        onClick: function () {
                            props.onSortByChange(SortByQueryOptions[key]);
                        }
                    };
                }) }));
    };
    //^ RESET
    var renderReset = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "reset-button", onClick: function () {
                    props.onReset();
                } }, "Reset Filters"));
    };
    //^ LOOPS & ONE SHOTS
    var renderLoopsOneShots = function () {
        var _a, _b, _c, _d;
        return React.createElement(React.Fragment, null,
            React.createElement(DropdownButton, { buttonText: 'Loops / One-Shots', className: (((_a = props.selectedTags) === null || _a === void 0 ? void 0 : _a.includes(LOOPS.name)) || ((_b = props.selectedTags) === null || _b === void 0 ? void 0 : _b.includes(ONE_SHOT.name))) ? 'has-filter' : '', width: '100%', buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", menuItems: [
                    {
                        text: LOOPS.name,
                        onClick: function () {
                            var _a;
                            props.onTagClick(((_a = props.selectedTags) === null || _a === void 0 ? void 0 : _a.includes(ONE_SHOT.name)) ? [LOOPS, ONE_SHOT] : LOOPS);
                        },
                        selected: (_c = props.selectedTags) === null || _c === void 0 ? void 0 : _c.includes(LOOPS.name)
                    },
                    {
                        text: ONE_SHOT.name,
                        onClick: function () {
                            var _a;
                            props.onTagClick(((_a = props.selectedTags) === null || _a === void 0 ? void 0 : _a.includes(LOOPS.name)) ? [LOOPS, ONE_SHOT] : ONE_SHOT);
                        },
                        selected: (_d = props.selectedTags) === null || _d === void 0 ? void 0 : _d.includes(ONE_SHOT.name)
                    }
                ] }));
    };
    //^ INSTRUMENTS
    var renderInstruments = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(DropdownButton, { buttonText: "Instruments", className: hasInstruments ? 'has-filter' : '', width: "100%", buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", menuItems: instrumentButtons }));
    };
    //^ KEY
    var renderKeyDropdown = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "key-container" },
                React.createElement(DropdownButton, { ref: keyDropDown, buttonText: "Key", className: props.selectedKey ? 'has-filter' : '', width: "100%", buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", open: showKeyboard, onClick: function () {
                        setShowKeyboard(true);
                    } }),
                React.createElement(Popper, { anchorEl: keyDropDown.current, placement: 'bottom', open: showKeyboard, modifiers: {
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'window',
                        }
                    }, transition: true, style: { zIndex: 300, pointerEvents: showKeyboard ? 'auto' : 'none' } }, function (transitionProps) {
                    return React.createElement(FadeAnimation, __assign({}, transitionProps.TransitionProps),
                        React.createElement(ClickAwayListener, { mouseEvent: showKeyboard ? 'onClick' : false, onClickAway: function () {
                                setShowKeyboard(false);
                            } },
                            React.createElement("div", { className: 'complex-dropddown ' + (showKeyboard ? "slide-down" : "slide-up ") },
                                React.createElement(Keyboard, { onKeyChange: props.onKeyClick, onKeyTypeChange: props.onSelectedKeyTypeChange, onBPMChange: props.onBPMChange, selectedKey: props.selectedKey, keyType: props.selectedKeyType }))));
                })));
    };
    //^ GENRES
    var renderGenres = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(DropdownButton, { buttonText: "Genres", width: "100%", className: ((props.selectedGenre && props.selectedGenre.length) || (props.selectedSubGenres && props.selectedSubGenres.length)) ? 'has-filter' : '', buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", menuItems: genres.map(function (genre) {
                    var _a;
                    return {
                        text: genre.name,
                        selected: ((_a = props.selectedGenre) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == genre.name.toLowerCase(),
                        onClick: function () {
                            props.onGenreClick(genre);
                        },
                        subItems: genre.SubGenres ? genre.SubGenres.map(function (subgenre) {
                            return {
                                text: subgenre.name,
                                onClick: function () {
                                    props.onSubGenreClick(subgenre);
                                },
                                selected: (props.selectedSubGenres || []).includesLowercase(subgenre.name),
                            };
                        }) : undefined
                    };
                }) }));
    };
    //^ BPM SLIDER
    var renderBPMSlider = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "slider-container" },
                React.createElement(DropdownButton, { ref: bpmDropDown, buttonText: "BPM", width: "100%", className: (props.bpmMin != undefined && props.bpmMin != 0 || props.bpmMax != undefined && props.bpmMax != 200) ? 'has-filter' : '', buttonImageRight: CHEVRON_DOWN_SVG, buttonImageWidth: "10", open: showBPM, onClick: function () {
                        setShowBPM(true);
                    } }),
                React.createElement(Popper, { anchorEl: bpmDropDown.current, open: showBPM, modifiers: {
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'window',
                        }
                    }, transition: true, style: { zIndex: 300, pointerEvents: showBPM ? 'auto' : 'none' } }, function (transitionProps) {
                    return React.createElement(FadeAnimation, __assign({}, transitionProps.TransitionProps),
                        React.createElement(ClickAwayListener, { mouseEvent: showBPM ? 'onClick' : false, onClickAway: function () {
                                setShowBPM(false);
                            } },
                            React.createElement("div", { className: 'complex-dropddown ' + (showBPM ? "slide-down" : "slide-up") },
                                React.createElement(BPMSlider, { showHalfTime: props.showHalfTime, onHalftimeChange: props.onHalfTimeChange, onSliderChange: props.onBPMChange, sliderMin: props.bpmMin, sliderMax: props.bpmMax, checkmarkText: 'Show half-time', caption: 'BPM', captionOrientation: 'top' }))));
                })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Filter" },
            React.createElement("div", { className: "single-button-container sort-by" },
                props.renderFilterItems && props.renderFilterItems(props, {
                    renderNewest: renderNewest,
                    renderLoopsOneShots: renderLoopsOneShots,
                    renderInstruments: renderInstruments,
                    renderGenres: renderGenres,
                    renderBPMSlider: renderBPMSlider
                }),
                !props.renderFilterItems && React.createElement(React.Fragment, null,
                    renderNewest(),
                    renderLoopsOneShots(),
                    renderInstruments(),
                    renderKeyDropdown(),
                    renderGenres(),
                    renderBPMSlider()))),
        React.createElement("div", { className: "Filter-Divider" })));
};
export default Filter;
//# sourceMappingURL=Filter.js.map